export const namespaced = true;

export const state = {
  announcements: []
};

let nextId = 1;

export const mutations = {
  PUSH(state, announcement) {
    // state.announcements.push({
    //   ...announcement,
    //   id: nextId++
    // });
    const allObj = Object.assign(announcement, {      
      id: nextId++
    });
    state.announcements.push(allObj);
  },
  CHANGE(state, announcement) {
    // state.announcements = [
    //   {
    //     ...announcement,
    //     id: nextId
    //   }
    // ];
    const allObj = Object.assign(announcement, {      
      id: nextId++
    });
    state.announcements = [allObj];
  }
};

export const actions = {
  add({ commit }, announcement) {
    commit("PUSH", announcement);
  },
  replace({ commit }, announcement) {
    commit("CHANGE", announcement);
  }
};
